import axios from "axios";

const API_BASE_URL =
  window.location.hostname === "localhost"
    ? "http://localhost/api_server"
    : "https://www.ppkm.org.my/api_server";

const authenticateAdminLogin = async (data: any) => {
  try {
    const response = await axios.post(`${API_BASE_URL}/admin_login/`, data);

    return response.data;
  } catch (error) {
    return error;
  }
};

const authenticateRequest = async (data: any) => {
  console.log(data);
  try {
    const response = await axios.post(
      `${API_BASE_URL}/authenticate_request/`,
      data
    );

    return response.data;
  } catch (error) {}
};

const verifyEmail = async (data: any) => {
  const payload ={
    email: data
  }
  console.log(payload);
  try {
    const response = await axios.post(
      `${API_BASE_URL}/verify_email/`,
      payload
    );

    return response.data;
  } catch (error) {}
};

const AdminResetPasswordbyUserID = async (userID, password) => {
  try {
    const response = await axios.post(
      `${API_BASE_URL}/admin_reset_password/`,
      {
        userID,
        password,
      }
    );

    // return response;
    console.log(response.data.success);
    console.log(response);

    if (response.data.success) {
      // Store MemberID in local storage
      return response.data; // Return the userId on successful login
    } else {
      throw new Error("Reset Failed");
    }
  } catch (error) {
    console.error(error);
    return null;
  }
};

const api = { authenticateAdminLogin, authenticateRequest, verifyEmail,AdminResetPasswordbyUserID };
export default api;
